import React from 'react';
import Course from '../Course';
import CourseGrouping from '../CourseGrouping';
import VideoPlayer from '../VideoPlayer';
import ChessBoard from '../ChessBoard';

import styled from 'styled-components';

import { DataContext } from '../DataProvider';

// import manifestData from '../../data/manifests.json';

function Body() {
  const {
    selectedCourse,
    catalog,
    lessons,
    selectedQuizId,
    selectedExerciseIndex,
  } = React.useContext(DataContext);

  var result = (
    <CourseGrid>
      {Object.keys(catalog).map((key) => (
        <CourseGrouping key={key['TITLE']} data={catalog[key]} />
      ))}
    </CourseGrid>
  );

  const videoContainer = !selectedQuizId ? (
    <VideoContainer>
      <VideoPlayer />
    </VideoContainer>
  ) : null;

  const chessExercise = selectedQuizId ? (
    <ChessBoardContainer>
      <ChessBoard quizId={selectedQuizId} exId={selectedExerciseIndex} />
    </ChessBoardContainer>
  ) : null;

  if (selectedCourse) {
    result = (
      <Layout>
        {videoContainer}
        {chessExercise}
        <LessonsList>
          <Course key={selectedCourse} data={lessons} />
        </LessonsList>
      </Layout>
    );
  }
  return result;
}

export default Body;

const Layout = styled.div`
  display: flex;
  height: 100vh;
  background-color: black;
  padding: 48px;
`;

const CourseGrid = styled.div`
  width: 100%;
  height: 100%;
`;

const LessonsList = styled.div`
  margin-left: 25px;
  width: 472px;
  overflow-y: scroll;
  height: 100%;
  color: white;

  &::-webkit-scrollbar-track {
    background: #000000;
  }

  &::-webkit-scrollbar-thumb {
    background: #282828;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }
`;

const ChessBoardContainer = styled.div`
  width: 80%;
`;

const VideoContainer = styled.div`
  width: 80%;
`;
